import { get, isEqual } from 'lodash-es';
import moment from 'moment';
import { parseToNumber } from './formatters';

/**
 * Generate `labelFormatter` props for `PopoverInput` component for `Select` input
 * @param {{ value, label }[]} optionList
 */
export const generatePopoverInputLabelFormatterForSelectInput = optionList => ({ label, value }) => {
  const selectedOption = optionList.find(option => option.value === value);
  return selectedOption
    ? selectedOption.label
    : label;
};

/**
 * Generate props for Form.Item Select to control full object value
 * @param {Object[]} options
 * @param {String} options.value
 */
export const generateSelectOptionFullValueControl = options => ({
  getValueFromEvent: (value, selectedOption) => {
    if (!options) {
      return selectedOption;
    }

    const filteredOptions = options.filter(opt => opt.value === value);
    return filteredOptions.length > 0
      ? filteredOptions[0]
      : null;
  },
  getValueProps: selectedOption => ({ value: selectedOption ? selectedOption.value : undefined })
});

export const generateShouldUpdateProps = (fields = []) => (
  (prevValue, curValue) => fields.some(
    field => !isEqual(get(prevValue, field), get(curValue, field))
  )
);

export const generateNumberFormatterFormItemProps = (displayFormatter, valueFormatter) => ({
  getValueFromEvent: e => (
    typeof valueFormatter === 'function'
      ? valueFormatter(parseToNumber(e.target.value))
      : parseToNumber(e.target.value)
  ),
  getValueProps: val => ({ value: displayFormatter(val) })
});

export const generateDateFormItemProps = (dateStringFormat = 'YYYY-MM-DD') => ({
  getValueFromEvent: value => (
    value && moment(value).isValid()
      ? moment(value).format(dateStringFormat)
      : undefined
  ),
  getValueProps: val => ({
    value: (
      val && moment(val).isValid()
        ? moment(val)
        : undefined
    )
  })
});

export default {};
